import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import axios from "axios";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(localizedFormat);

import { chooseImage } from "../util/Helpers";
import Vehicle from "../components/Vehicle";
import { downloadPdf } from "../util/DownloadPdf";

const damageIconColor = (v) => {
	// return v;
	if (v === 0) return "green";
	if (v > 0 && v < 6) return "orange";
	if (v > 5) return "red";
	// return "black";
};

const DamageDescription = {
	UNKNOWN: { text: "" },
	"FC - FRONT END DAMAGE CONCENTRATED IMPACT": {
		text: "Front end damage due to concentrated impact resulting from collision of subject vehicle with tree, utility pole, or other narrow object."
	},
	"FD - FRONT END DAMAGE DISTRIBUTED IMPACT": {
		text: "Front end damage due to distributed impact resulting from full contact of front end of subject vehicle with other vehicle or broad object."
	},
	"FL - FRONT END (LEFT) DAMAGE PARTIAL CONTACT": {
		text: "Front left corner damage due to partial contact of front end of subject vehicle with other vehicle or object."
	},
	"FR - FRONT END (RIGHT) DAMAGE PARTIAL CONTACT": {
		text: "Front right corner damage due to partial contact of front end of subject vehicle with other vehicle or object."
	},
	"BC - BACK END DAMAGE CONCENTRATED IMPACT": {
		text: "Rear end damage due to concentrated impact resulting from collision of subject vehicle with tree, utility pole, or other narrow object."
	},
	"BD - BACK END DAMAGE DISTRIBUTED IMPACT": {
		text: "Rear end damage due to distributed impact resulting from full contact of rear end of subject vehicle with another vehicle or object. Applicable to rear-end collisions."
	},
	"BL - BACK END (LEFT) DAMAGE PARTIAL CONTACT": {
		text: "Rear left corner damage due to partial contact or rear end of subject vehicle with another vehicle or object. Applicable to rear-end collisions"
	},
	"BR- BACK END (RIGHT) DAMAGE PARTIAL CONTACT": {
		text: "Rear right corner damage due to partial contact of rear end of subject vehicle with another vehicle or object. Applicable to rear-end collisions."
	},
	"LP - LEFT SIDE DAMAGE ANGULAR IMPACT": {
		text: "Left side damage in vicinity of passenger compartment due to angular impact by another vehicle or object. Applicable to angle collisions and crashes in which a vehicle strikes an object after skidding or spinning."
	},
	"RP - RIGHT SIDE DAMAGE ANGULAR IMPACT": {
		text: "Right side damage in vicinity of passenger compartment due to angular impact by another vehicle or object."
	},
	"LFQ - LEFT FRONT QUARTER DAMAGE ANGULAR IMPACT": {
		text: "Left front quarter damage (ahead of passenger compartment) due to angular impact by another vehicle or object. Applicable to angle collisions and crashes in which a vehicle strikes an object after skidding or spinning."
	},
	"RFQ - RIGHT FRONT QUARTER DAMAGE ANGULAR IMPACT": {
		text: "Right front quarter damage (ahead of passenger compartment) due to angular impact by another vehicle or object."
	},
	"LBQ - LEFT BACK QUARTER DAMAGE ANGULAR IMPACT": {
		text: "Left rear quarter damage (behind passenger compartment) due to angular impact by another vehicle or object. Applicable to angle collisions and crashes in which a vehicle strikes an object after skidding or spinning."
	},
	"RBQ - RIGHT BACK QUARTER DAMAGE ANGULAR IMPACT": {
		text: "Right rear quarter damage (behind passenger compartment) due to angular impact by another vehicle or object."
	},
	"LD - DISTRIBUTED LEFT SIDE DAMAGE PARALLEL IMPACT": {
		text: "Left side damage resulting from sideswipe by meeting or overtaking other vehicle or object."
	},
	"RD - DISTRIBUTED RIGHT SIDE DAMAGE PARALLEL IMPACT": {
		text: "Right side damage resulting from sideswipe by meeting or overtaking other vehicle or object."
	},
	"L&T - LEFT SIDE AND TOP DAMAGE ROLLOVER EFFECTS": {
		text: "Left side and top damage due to rollover. Right side and top damage due to rollover."
	},
	"R&T - RIGHT SIDE AND TOP DAMAGE ROLLOVER EFFECTS": {
		text: "Right side and top damage due to rollover."
	},
	"VX-0 - UNDERCARRIAGE DAMAGE ONLY": {
		text: "Damage to the underneath of the vehicle only."
	},
	"VB-1 - VEHICLE BURNED NOT DUE TO COLLISION (ENGINE CATCHE": {
		text: "Vehicle burned, NOT due to collision (engine catches fire, cigarette burns upholstery, etc.)"
	},
	"VB-7 - VEHICLE CATCHES FIRE DUE TO THE COLLISION (VEHICLE": {
		text: "Vehicle catches fire due to the collision (vehicle collides with object or another vehicle and fire starts)."
	},
	"N/A - NOT APPLICABLE ( FARM TRACTOR, ETC.)": {
		text: "Farm tractor, train, pedalcyclist, wheelchair, motorized conveyance, streetcar, animal carrying person, etc."
	},
	"TP-0 - TOP DAMAGE ONLY": {
		text: "Damage to the top of the vehicle only."
	},
	"MC-1 - MOTORCYCLE, SCOOTER, MOPED, ETC. ONLY": {
		text: "Motorcycle, moped, scooter, etc."
	},
	"VEHICLE BURNED": { text: "" },
	"INVALID VALUE": { text: "" }
};

export const savePdf = async (setDownloading) => {
	try {
		setDownloading(true);
		const headers = {
			"page-referrers": window.location.href,
			"Cache-Control": "no-cache,no-store"
		};
		await axios
			.get("/accident/download-pdf", {
				headers,
				responseType: "arraybuffer"
			})
			.then((response) => {
				downloadPdf(response.data, "MyAccident.org-report.pdf");
			})
			.finally(() => setDownloading(false));
	} catch (e) {
		console.log('Something went wrong');
	}
};

export default function Pdf({ a, userData }) {
	useEffect(() => {
		document.title = "PDF Report";
		document.getElementsByTagName("body")[0].id = "PDF-REPORT";
	}, []);
	const [downloading, setDownloading] = useState(false);
	// console.log(a);

	// function damageAreaMark(d) {
	// 	if (d) {
	// 		let cl = d.split(" - ");
	// 		if (
	// 			cl &&
	// 			cl.length > 1 &&
	// 			cl[0] !== "VX-0" &&
	// 			cl[0] !== "VB-1" &&
	// 			cl[0] !== "VB-7" &&
	// 			cl[0] !== "N/A" &&
	// 			cl[0] !== "TP-0" &&
	// 			cl[0] !== "MC-1"
	// 		)
	// 			return (
	// 				<img
	// 					src="/assets/pdf/attention.svg"
	// 					className={"attention " + cl[0].replace("&", "")}
	// 				/>
	// 			);
	// 	}
	// }

	return (
		<div>
			<div id="top-buttons">
				<button
					onClick={() => {
						savePdf(setDownloading);
					}}
					style={{
						pointerEvents: downloading ? "none" : "all",
						opacity: downloading ? 0.5 : 1
					}}
				>
					{downloading ? "Generating PDF..." : "Download PDF"}
				</button>{" "}
				<button onClick={() => window.print()}>Print</button>
			</div>
			<div className="PDF-report">
				<header>
					{userData.website ? (
						<a href={userData.website} className="website" target="_blank">
							{userData.website}
						</a>
					) : null}
					<img src={userData.logo} className="logo" />
					<div className="created">
						Created On: {new Date().toLocaleDateString()}
						<br />
						{userData.createdBy ? `Created by: ${userData.createdBy}` : ""}
						<br />
						{userData.createdPhoneNumber
							? `Phone: ${userData.createdPhoneNumber}`
							: ""}
						<br />
					</div>
					<h1>
						MYACCIDENT <span>REPORT</span>
					</h1>
					<div className="Rectangle-4"></div>
					<div className="Accident-Location">
						Accident Location: {a.location_address}, {a.county}
					</div>
					<div className="date">On: {dayjs.utc(a.date).format("llll")}</div>
					<div className="Rectangle-5"></div>
					<div className="case-ids">
						<div>
							<span>Crash ID: </span>
							{a.crash_id}
						</div>
						<div>
							<span>Case ID: </span>
							{a.caseID ? a.caseID : "-"}
						</div>
						{userData.businessCaseID ? (
							<div>
								<span>{userData.business_name} Case #: </span>
								{userData.businessCaseID ? userData.businessCaseID : ""}
							</div>
						) : null}
					</div>
					<h2>
						Accident report {userData.createdFor ? " for " : null}{" "}
						{userData.createdFor ? <span>{userData.createdFor}</span> : null}
					</h2>
					<div className="triangle-1"></div>
					<div className="triangle-2"></div>
				</header>
				<div className="container">
					<div className="map">
						<img
							src={`https://maps.googleapis.com/maps/api/staticmap?center=${a.location_lat},${a.location_lng}&zoom=13&scale=1&size=600x300&maptype=roadmap&key=AIzaSyCb4X58O574pZiBot_hf3N9q_bGu9yO8i8&format=png&visual_refresh=true&markers=icon:https://myaccident.org/images/location-pin-01.webp%7Cshadow:false%7C${a.location_lat},${a.location_lng}`}
							width="100%"
							height="100%"
							style={{ objectFit: "cover" }}
						/>
						<div className="accident-in-short">
							<h3>
								ACCIDENT
								<br />
								CONTRIBUTING
								<br />
								FACTORS
							</h3>
							{a.accident_contributing_factors}
						</div>
						<div className="police">
							<img src="/assets/pdf/dallas-police-badge-logo@3x.png" />
							<span>{a.agency}</span>
							Non-Emergency Number:
							<br />
							{a.non_emergency_number}
						</div>
						<div className="conditions">
							<h3>conditions on {new Date(a.date).toLocaleString()}</h3>
							<div>
								<span>
									<img src="/assets/pdf/road.svg" />
									{a.traffic_conditions}
								</span>
								<span>
									<img src="/assets/pdf/clear.svg" />
									{a.weather_conditions}
								</span>
								<span>
									<img src="/assets/pdf/traffic.svg" />
									NONE
								</span>
							</div>
						</div>
					</div>

					<section>
						<h1>
							<span>
								<img src="/assets/pdf/key-facts.svg" /> KEY FACTS
							</span>
						</h1>
						<div className="key-facts-icons">
							<div className="icon">
								<h4>VEHICLES</h4>
								<div style={{ flexDirection: "column" }}>
									{a.vehicles.length}
								</div>
							</div>

							<div className="icon">
								<h4>OCCUPANTS</h4>
								<div style={{ flexDirection: "column" }}>
									{a.non_injury_count + a.total_injury_count || a.people_count}
								</div>
							</div>

							<div className="icon">
								<h4>INJURIES</h4>
								<div style={{ flexDirection: "column" }}>
									{a.total_injury_count}
								</div>
							</div>

							<div className="icon">
								<h4>SPEED LIMIT</h4>
								<div style={{ flexDirection: "column" }}>
									{a.crash_speed_limit > 0
										? a.crash_speed_limit + " mph"
										: "N/A"}
								</div>
							</div>
						</div>

						<div className="key-facts-block">
							<h3 style={{ marginTop: -27, marginBottom: 7 }}>
								Accident Summary
							</h3>
							{a.description}
							{a.summary}
							{a.narrative ? (
								<div>
									<h3 style={{ marginTop: 20, marginBottom: 7 }}>
										Additional Narrative
									</h3>
									{a.narrative}
								</div>
							) : null}
						</div>
						<div style={{ clear: "both" }}></div>
					</section>

					<section>
						<h1>
							<span>
								<img src="/assets/pdf/car-icon-white.svg" /> VEHICLE SUMMARY
							</span>
						</h1>
						<div className="row">
							{a.vehicles.map((v, k) => (
								<div className="column" key={k}>
									<div className="car-holder">
										<Vehicle v={v} alt />
									</div>
									{/* <div className={"car-holder " + chooseImage(v)}>
										<img
											src={
												"/assets/types/" +
												chooseImage(v) +
												".png"
											}
										/>
										{damageAreaMark(v.damage_area_1)}
										{damageAreaMark(v.damage_area_2)}
									</div> */}
									<div className="car-info">
										{v.contributing_factor1 !== "NONE" ? (
											<div className="at-fault-ribbon">AT FAULT</div>
										) : (
											""
										)}
										<h2>{v.vehicle_maker ? v.vehicle_maker : "Unknown"}</h2>
										<div className="color">
											{v.vehicle_color
												? v.vehicle_color + ", " + v.vehicle_model_year
												: "Unknown color" + ", " + v.vehicle_model_year}
										</div>
										<p>
											<strong>Vehicle Lic State ID: </strong>
											{v.vehicle_license_state}
										</p>
										<p>
											<strong>VIN: </strong>
											{v.vin_code}
										</p>
										<p>
											<strong>Damage Area: </strong>
											{DamageDescription[v.damage_area_1]
												? DamageDescription[v.damage_area_1].text
												: ""}
											{DamageDescription[v.damage_area_2]
												? DamageDescription[v.damage_area_2].text
												: ""}
										</p>
									</div>
									{v.damage_severity_1_id ? (
										<div
											className={
												"damage-level " +
												damageIconColor(Number(v.damage_severity_1_id))
											}
										>
											DAMAGE
											<br />
											<img
												src={`/assets/pdf/damage-icon-${v.damage_severity_1_id}.svg`}
											/>
											<br />
											LEVEL {v.damage_severity_1_id}
										</div>
									) : null}
								</div>
							))}
						</div>
					</section>

					<section>
						<h1>
							<span>
								<img src="/assets/pdf/driver-information.png" />
								DRIVER INFORMATION
							</span>
						</h1>

						<div className="row">
							{a.vehicles.map((v) => {
								return v.participants.map((p, n) => {
									if (n === 0)
										return (
											<div className="column box" key={n}>
												{v.contributing_factor1 !== "NONE" ? (
													<div className="at-fault-ribbon">AT FAULT</div>
												) : (
													""
												)}
												<h2>{v.vehicle_maker} Driver</h2>
												<div className="color">
													{v.vehicle_color
														? v.vehicle_color + ", " + v.vehicle_model_year
														: "Unknown color" + ", " + v.vehicle_model_year}
												</div>
												<p>
													<strong>Driver Licence Type: </strong>
													{p.driver_license_type
														? String(p.driver_license_type).toLowerCase()
														: "-"}
												</p>
												<p>
													<strong>Insurance: </strong>
													{v.insurance
														? String(v.insurance).toLowerCase()
														: "NO - Driver did not provide proof of insurance"}
													{v.insurance_company
														? ", " + v.insurance_company
														: null}
												</p>
												<p>
													<strong>Age, gender, ethnicity: </strong>
													{p.person_age +
														", " +
														p.gender +
														", " +
														(p.ethnicity
															? p.ethnicity.toLowerCase()
															: "Unknown ethnicity")}
												</p>
												<p>
													<strong>Resident of: </strong>
													{p.resident}
												</p>
												<p>
													<strong>Injury report: </strong>
													{p.injury}
												</p>
												{p.citation_charge_number ? (
													<p>
														<strong>Charge Number:</strong>{" "}
														{p.citation_charge_number}
													</p>
												) : (
													""
												)}
												{!p.specimen || p.specimen === "NONE" ? (
													""
												) : (
													<p className="alcohol-test">{p.specimen}</p>
												)}

												{v.towing_company &&
												v.towing_company !==
													"DRIVEN AWAY BY LICENSED DRIVER" ? (
													<div className="tow-truck-box">
														<div>Tow Truck Information</div>
														<span>
															{v.towing_company}
															<br />
															{v.towing_location}
														</span>
													</div>
												) : (
													""
												)}
											</div>
										);
								});
							})}
						</div>

						<div style={{ clear: "both" }}></div>
					</section>

					<section>
						<h1>
							<span>
								<img src="/assets/pdf/safety-information.svg" /> SAFETY
								INFORMATION
							</span>
						</h1>
						{a.vehicles.map((v, k) => (
							<div key={k}>
								<div className="car-holder">
									<Vehicle v={v} boxed />
									{/* <div className={"car-holder " + chooseImage(v)}>
									<img
										src={
											"/assets/types/" +
											chooseImage(v) +
											".png"
										}
									/> */}
									{/*v.participants.map((p, c) => (
										<div
											className={
												"boxed-icon position-" +
												(c + 1) +
												(p.positionClass ? " " + p.positionClass : "") +
												(p.injury === "NOT INJURED" ? " green" : " orange") +
												" " +
												p.position?.replace(/ /g, "_").toUpperCase()
											}
										>
											<img src="/assets/pdf/passenger-icon.svg" />
											<span>{c + 1}</span>
										</div>
										))=*/}
								</div>
								<div className="car-info full">
									{v.contributing_factor1 !== "NONE" ? (
										<div className="at-fault-ribbon">AT FAULT</div>
									) : (
										""
									)}
									<h2>{v.vehicle_maker ? v.vehicle_maker : "Unknown"}</h2>
									<div className="color">
										{v.vehicle_color
											? v.vehicle_color + ", " + v.vehicle_model_year
											: "Unknown color" + ", " + v.vehicle_model_year}
									</div>
									<table>
										<thead>
											<tr>
												<th>OCCUPANT</th>
												<th>SAFETY BELT</th>
												<th>AIRBAGS</th>
												<th>OTHER</th>
												<th>DESCRIPTION</th>
											</tr>
										</thead>
										<tbody>
											{v.participants.map((p, c) => {
												let seatBeltClassColor = "green";
												if (p.seatbelt === "NONE") seatBeltClassColor = "red";
												if (p.seatbelt === "UNKNOWN")
													seatBeltClassColor = "orange";

												let airbagClassColor = "red";
												if (
													p.airbag === "UNKNOWN" ||
													p.airbag === "NOT DEPLOYED"
												)
													airbagClassColor = "green";
												if (p.airbag === "NOT APPLICABLE")
													airbagClassColor = "black";

												let injuryClassColor = "orange";
												if (p.injury === "NOT INJURED")
													injuryClassColor = "green";

												return (
													<tr key={c}>
														<td>
															<div className={"boxed-icon " + injuryClassColor}>
																<img src="/assets/pdf/passenger-icon.svg" />
																<span>{c + 1}</span>
															</div>
														</td>
														<td>
															<div
																className={"boxed-icon " + seatBeltClassColor}
															>
																<img src="/assets/pdf/seatbelt-icon.svg" />
															</div>
														</td>
														<td>
															<div className={"boxed-icon " + airbagClassColor}>
																<img src="/assets/pdf/airbag-icon.svg" />
															</div>
														</td>
														<td></td>
														<td>
															<strong>
																{p.type ? p.type : "Person " + (c + 1)},{" "}
																{p.person_age} years old, {p.gender}{" "}
																{p.ethnicity ? ", " + p.ethnicity + ", " : ""}
															</strong>
															{p.injury}, Seatbelt: {p.seatbelt}, Airbags:{" "}
															{p.airbag}
														</td>
													</tr>
												);
											})}
										</tbody>
									</table>
								</div>
								<div style={{ clear: "both", height: "50px" }}></div>
							</div>
						))}
					</section>
				</div>
				<footer>{userData.footer}</footer>
			</div>
		</div>
	);
}
